"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utf8Encoder = new TextEncoder();
const utf8Decoder = new TextDecoder();
const utf8 = {
    decode: function Utf8Decode(input) {
        return utf8Decoder.decode(input);
    },
    encode: function Utf8Encode(input) {
        const buf = utf8Encoder.encode(input);
        return new Uint8Array(buf, 0, buf.length);
    }
};
exports.default = utf8;
